module.exports = "/_next/static/images/discreet-22d99a4663ba001282d26ba1abde5800.svg";